import axios from "axios";
import { clearSession, getAccessTokenRef, setAccessTokenRef } from "../services/authHelper";
import { setAccessToken } from "./authService";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/api/v1",
  withCredentials: true,
});

let refreshPromise = null;

const retryWithNewToken = async (error) => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/auth/refresh-token`, {}, { withCredentials: true })
      .then(({ data }) => {
        setAccessTokenRef(data.accessToken);
        setAccessToken(data.accessToken);
        return data.accessToken;
      })
      .catch((err) => {
        clearSession();
        throw err;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  try {
    const newToken = await refreshPromise;
    error.config.headers.Authorization = `Bearer ${newToken}`;
    return apiClient(error.config);
  } catch (refreshError) {
    return Promise.reject(refreshError);
  }
};

// ✅ Interceptor de peticiones: agrega el token si existe
apiClient.interceptors.request.use(
  (config) => {
    const token = getAccessTokenRef();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const httpStatus = error.response?.status;
    const backendStatus = error.response?.data?.status;

    // 🟡 Caso recuperable: token rotado por otra pestaña / doble request
    if (httpStatus === 403 && backendStatus === -3) {
      console.log("🔁 Concurrency issue (-3). Reintentando refresh...");
      return retryWithNewToken(error);
    }

    // 🟡 Expiración normal de access token → refrescar
    if (httpStatus === 401 && !error.config._retry) {
      error.config._retry = true;
      return retryWithNewToken(error);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
